import { MutableValue } from "@/modules/api/mutable-value.interface";

export default class BulkShipmentBox implements MutableValue {
  public isNew = true;

  constructor(
    private fId: string,
    private fBoxNumber: number,
    private fLength: number,
    private fWidth: number,
    private fHeight: number,
    private fWeight: number
  ) {
    [fId, fBoxNumber, fLength, fWidth, fHeight, fWeight].forEach(
      (arg, index) => {
        if (arg === undefined || arg === null) {
          throw new Error(`Undefined value passed at position: ${index}`);
        }
      }
    );
  }

  get id(): string {
    return this.fId;
  }

  get boxNumber(): number {
    return this.fBoxNumber;
  }

  get length(): number {
    return this.fLength;
  }

  get width(): number {
    return this.fWidth;
  }

  get height(): number {
    return this.fHeight;
  }

  get weight(): number {
    return this.fWeight;
  }
}
